import React from 'react';
import { statusTypes } from '../../../mls-match-list/utils';
import { useReactAppState } from '../../../shared/containers/utils';
import StatusLiveStamp from '../../../shared/components/StatusStamp/StatusLiveStamp/StatusLiveStamp';

function MatchStatus({ matchStatus, minutes, extraMinutes, dateLabel, matchTime, isTimeTbd }) {
  const { t } = useReactAppState();
  const status = matchStatus?.abbreviation;

  if (status === statusTypes.live) {
    return (
      <div className="mls-c-priority-match__date-time mls-c-priority-match__date-time--live">
        <StatusLiveStamp minuteDisplay={minutes} extraMinutes={extraMinutes} />
      </div>
    );
  }

  if (status === statusTypes.post || status === statusTypes.finalWhistle) {
    return (
      <div className="mls-c-priority-match__date-time">
        <span className="mls-c-priority-match__final">{t('match_final')}</span>
      </div>
    );
  }

  return (
    <div className="mls-c-priority-match__date-time">
      <span className="mls-c-priority-match__date">{dateLabel}</span>
      {!isTimeTbd && matchTime && (
        <span className="mls-c-priority-match__time">{matchTime}</span>
      )}
      {isTimeTbd && (
        <span className="mls-c-priority-match__time mls-c-priority-match__time--tbd">
          {t('tbd')}
        </span>
      )}
    </div>
  );
}

export default MatchStatus;
